export class LocationDistance {
    parent_Id: string;
    id: string;
    name: string;
    distance: number;
}